// Polyfill for Promise.withResolvers (required by Apollo Client 3.12+ / graphql-ws)
// Not available in Firefox < 121, Safari < 17.4
if (typeof (Promise as any).withResolvers === "undefined") {
  (Promise as any).withResolvers = function <T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

import * as Sentry from "@sentry/browser";
import Dynamsoft from "dwt";
import { createRoot } from "react-dom/client";
import App from "./App";

Dynamsoft.DWT.ProductKey = `${import.meta.env.VITE_DYNAMSOFT_PRODUCTKEY}`;
Dynamsoft.DWT.ResourcesPath = `/${import.meta.env.VITE_DYNAMSOFT_RESOURCEPATH}`;
Dynamsoft.DWT.Containers = [{ ContainerId: "dwtcontrolContainer", Width: 270, Height: 350 }];

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENV,
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "TypeError: NetworkError when attempting to fetch resource.",
      "Failed to fetch",
      "Invalid Token",
      "cancelled",
      "Load failed",
      /network error/i,
    ],
    release: import.meta.env.VITE_CI_COMMIT_SHORT_SHA,
  });
  Sentry.setTag("CI_COMMIT_SHORT_SHA", import.meta.env.VITE_CI_COMMIT_SHORT_SHA);
}
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
